import { useConfig } from "../../../lib/config";
import { useHttpClient } from "../../../lib/http";
import { useCampingMapApi } from "../infraestructure/campingMap.api";
import { CampingMapEntity } from "../infraestructure/campingMap.dto";

export function useCampingMapService(propertyTicker: string) {
  const config = useConfig();
  const httpClient = useHttpClient(config.middlewareEndpoint);
  const { getCampingMap, updateCampingMap } = useCampingMapApi(httpClient);

  return {
    getOne: () => getCampingMap(propertyTicker),
    update: (entity: CampingMapEntity) => updateCampingMap(propertyTicker, entity),
  };
}
